/**
 * '9031112233', '+7 ___ ___ __ __' => "+7 903 111 22 33"
   '903', '+7 ___ ___ __ __' => "+7 903"
   '224', '_ + _ = _' => "2 + 2 = 4"
 */
export const maskValue = (value: string, mask: string) => {
  const [result] = Array.from(mask).reduce(
    ([_mask, _value], v, i) => {
      if (v !== '_') return [_mask, _value] as [string, string];
      if (!_value) return [_mask.slice(0, i), _value] as [string, string];
      const nextArray = [...Array.from(_mask)];
      nextArray.splice(i, 1, _value[0] ?? '');
      const next = [nextArray.join(''), _value.slice(1)] as [string, string];
      return next as [string, string];
    },
    [mask, value] as [string, string],
  );

  return result.replace(/_/g, '').trimEnd();
};
